import React from 'react';
const ActivityLargeBox = (props) => (
  // <div className="flex flex-col flex-wrap max-w-5xl mx-3 mt-3 bg-white rounded shadow min-w-max h-428">
  <div className='flex flex-col flex-wrap h-auto max-w-5xl mx-3 mt-3 bg-white rounded shadow min-w-max'>
    <div className='flex w-full px-6 pt-3'>
      <div className='w-3/5 text-xl font-bold uppercase text-summary-header '>{props.header}</div>
      <div className='pt-2 text-sm capitalize text-secondary '>{props.subHeader}</div>
    </div>
    {/* <div className="block h-24 px-6 pt-3">
      <div className="pt-3 text-xl font-semibold uppercase text-summary-header ">{props.header}</div>
      <div className="pt-3 text-sm capitalize text-summary-header ">{props.subHeader}</div>
    </div> */}
    <div className='relative flex flex-row flex-wrap justify-center'>
      <div className='content-center justify-center p-2 my-auto h-72'>
        <div className='flex justify-center w-auto'>
          {props.graphCenter}
          {props.graphData}
        </div>
      </div>
      <div className='justify-center p-5 pt-16'>{props.graphLegend}</div>
    </div>
  </div>
);

export default ActivityLargeBox;
